<template>
  <div class="register_container">
    <div class="top-layout">
      <i class="el-icon-arrow-left" @click="goLogin"></i>
      <div>{{ $t('account.name32') }}</div>
    </div>
    <div class="register-content">
        <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane :label="$t('account.name34')" name="first">
        <div class="register">
        <el-form ref="registerFormRef" :model="registerForm" :rules="registerFormRules" label-width="0px" class="login_form">
          <el-form-item prop="phoneNo">
            <el-input v-model="registerForm.phoneNo" :placeholder="$t('retrievePassword.name11')"  @input="handleInput"></el-input>
          </el-form-item>
          <div class="code-layout">
            <el-form-item prop="verCode" style="width:100%;">
              <el-input v-model="registerForm.verCode" type="text" :placeholder="$t('retrievePassword.name4')" class="code-input"  @input="handleInput"></el-input>
            </el-form-item>
            <el-button class="code"  size="small" :loading="codeLoading" type="primary" @click="getVerCode(1)">{{ sendmsg }}</el-button>
          </div>
          <el-form-item prop="loginPwd">
            <el-input v-model="registerForm.loginPwd" :placeholder="$t('retrievePassword.name6')" show-password></el-input>
          </el-form-item>
          <el-form-item prop="againPwd">
            <el-input v-model="registerForm.againPwd" :placeholder="$t('retrievePassword.name7')" show-password></el-input>
          </el-form-item>
          <el-form-item prop="userName">
            <el-input v-model="registerForm.userName" :placeholder="$t('account.name36')"></el-input>
          </el-form-item>
          <el-form-item prop="nickName">
            <el-input v-model="registerForm.nickName" :placeholder="$t('account.name37')"></el-input>
          </el-form-item>
          <el-form-item prop="storeAddress">
            <el-input v-model="registerForm.storeAddress" :placeholder="$t('account.name38')"></el-input>
          </el-form-item>
        </el-form>
          <div class="yszc"> <el-checkbox v-model="checked"></el-checkbox><div>{{ $t('account.name40') }}</div><div class="blue" @click="goXy">{{ $t('account.name41') }}</div></div>
        <el-button class="btns margin-top20" :loading="loading" type="primary" @click="sumbit(1)">{{ $t('retrievePassword.name8') }}</el-button>
        <div class="btns text-style" @click="goLogin">{{ $t('account.name39') }}</div>
      </div>
    </el-tab-pane>
    <el-tab-pane :label="$t('account.name35')" name="second">
        <div class="register">
        <el-form ref="registerFormRef1" :model="registerForm" :rules="registerFormRules1" label-width="0px" class="login_form">
          <el-form-item prop="email">
            <el-input v-model="registerForm.email" :placeholder="$t('retrievePassword.name3')"></el-input>
          </el-form-item>
          <div class="code-layout">
            <el-form-item prop="verCode" style="width:100%;">
              <el-input v-model="registerForm.verCode" type="text" :placeholder="$t('retrievePassword.name4')" class="code-input"  @input="handleInput"></el-input>
            </el-form-item>
            <el-button class="code"  size="small" :loading="codeLoading" type="primary" @click="getVerCode(2)">{{ sendmsg }}</el-button>
          </div>
          <el-form-item prop="loginPwd">
            <el-input v-model="registerForm.loginPwd" :placeholder="$t('retrievePassword.name6')" show-password></el-input>
          </el-form-item>
          <el-form-item prop="againPwd">
            <el-input v-model="registerForm.againPwd" :placeholder="$t('retrievePassword.name7')" show-password></el-input>
          </el-form-item>
          <el-form-item prop="userName">
            <el-input v-model="registerForm.userName" :placeholder="$t('account.name36')"></el-input>
          </el-form-item>
          <el-form-item prop="nickName">
            <el-input v-model="registerForm.nickName" :placeholder="$t('account.name37')"></el-input>
          </el-form-item>
          <el-form-item prop="storeAddress">
            <el-input v-model="registerForm.storeAddress" :placeholder="$t('account.name38')"></el-input>
          </el-form-item>
        </el-form>
          <div class="yszc"> <el-checkbox v-model="checked1"></el-checkbox><div>{{ $t('account.name40') }}</div><div class="blue" @click="goXy">{{ $t('account.name41') }}</div></div>
        <el-button class="btns margin-top20" :loading="loading" type="primary" @click="sumbit(2)">{{ $t('retrievePassword.name8') }}</el-button>
        <div class="btns text-style" @click="goLogin">{{ $t('account.name39') }}</div>
      </div>
    </el-tab-pane>
  </el-tabs>
    </div>
  </div>
</template>
<script>
import { validatePhone, validatePass, validateEmail } from '@/utils/utils.js'
import { phoneRegisterUser, sendPhoneRegisterVerCode, registerSendEmailCode, emailRegisterUser } from '@/api/h5.js'
export default {
  data() {
    var validateRePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('retrievePassword.name14')))
      } else if (value !== this.registerForm.loginPwd) {
        callback(new Error(this.$t('retrievePassword.name15')))
      } else {
        callback()
      }
    }
    return {
      activeName: 'first',
      // 这是登录表单的数据对象
      registerForm: {
        email: '',
        phoneNo: '',
        verCode: '',
        loginPwd: '',
        againPwd: '',
        userName: '',
        nickName: '',
        storeAddress: ''
      },
      // 这是表单验证规则对象
      registerFormRules: {
        // 验证用户名是否合法
        phoneNo: [
          {
            required: true,
            validator: validatePhone,
            trigger: 'blur'
          }
        ],
        verCode: [
          {
            required: true,
            trigger: 'blur'
          }
        ],
        loginPwd: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        againPwd: [
          {
            required: true,
            validator: validateRePass,
            trigger: 'blur'
          }
        ]
      },
      registerFormRules1: {
        // 验证用户名是否合法
        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        verCode: [
          {
            required: true,
            trigger: 'blur'
          }
        ],
        loginPwd: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        againPwd: [
          {
            required: true,
            validator: validateRePass,
            trigger: 'blur'
          }
        ]
      },
      isShowYS: false,
      loading: false,
      checked: false,
      checked1: false,
      code: '',
      codeLoading: false,
      readonlyInput: true,
      isSend: true,
      sendmsg: this.$t('retrievePassword.name12')
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      }
    }
  },
  mounted() {},
  methods: {
    handleInput() {
      this.registerForm.phoneNo = this.registerForm.phoneNo.replace(/\D/g, '')
      this.registerForm.verCode = this.registerForm.verCode.replace(/\D/g, '')
    },
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields()
    },
    showYS() {
      this.isShowYS = !this.isShowYS
    },
    goLogin() {
      this.$router.replace('/login')
    },
    goXy() {
      this.$router.push('/agreement')
    },
    getVerCode(type) {
      if (type === 1) {
        if (this.registerForm.phoneNo && this.registerForm.phoneNo.length === 11) {
          this.codeLoading = true
          const params = {
            phoneNo: 'CN-86-' + this.registerForm.phoneNo
          }
          sendPhoneRegisterVerCode(params)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: this.$t('public.name17'),
                  type: 'success'
                })
                this.isSend = false
                let timer = 60
                this.sendmsg = timer + 's'
                this.timeFun = setInterval(() => {
                  --timer
                  this.sendmsg = timer + 's'
                  if (timer === 0) {
                    this.isSend = true
                    this.sendmsg = this.$t('retrievePassword.name13')
                    clearInterval(this.timeFun)
                  }
                }, 1000)
              }
              this.codeLoading = false
            })
            .catch(() => {
              this.codeLoading = false
            })
        }
      } else {
        this.codeLoading = true
        const params = {
          email: this.registerForm.email
        }
        registerSendEmailCode(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: this.$t('public.name17'),
                type: 'success'
              })
              this.isSend = false
              let timer = 60
              this.sendmsg = timer + 's'
              this.timeFun = setInterval(() => {
                --timer
                this.sendmsg = timer + 's'
                if (timer === 0) {
                  this.isSend = true
                  this.sendmsg = this.$t('retrievePassword.name13')
                  clearInterval(this.timeFun)
                }
              }, 1000)
            }
            this.codeLoading = false
          })
          .catch(() => {
            this.codeLoading = false
          })
      }
    },
    sumbit(type) {
      if (type === 1) {
        if (!this.checked) {
          return this.$message({ message: this.$t('account.name48'), type: 'warning' })
        }
        this.$refs.registerFormRef.validate((valid) => {
          if (valid) {
            this.loading = true
            const registerForm = {
              phoneNo: 'CN-86-' + this.registerForm.phoneNo,
              verCode: this.registerForm.verCode,
              loginPwd: this.registerForm.loginPwd,
              userName: this.registerForm.userName,
              nickName: this.registerForm.nickName,
              storeAddress: this.registerForm.storeAddress
            }
            phoneRegisterUser(registerForm)
              .then((res) => {
                if (res.code === 200) {
                  this.$message({ type: 'success', message: '注册成功!' })
                  this.$router.replace('/login')
                }
                this.loading = false
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            return false
          }
        })
      } else {
        if (!this.checked1) {
          return this.$message({ message: this.$t('account.name48'), type: 'warning' })
        }
        this.$refs.registerFormRef1.validate((valid) => {
          if (valid) {
            this.loading = true
            const registerForm = {
              email: this.registerForm.email,
              verCode: this.registerForm.verCode,
              loginPwd: this.registerForm.loginPwd,
              userName: this.registerForm.userName,
              nickName: this.registerForm.nickName,
              storeAddress: this.registerForm.storeAddress
            }
            emailRegisterUser(registerForm)
              .then((res) => {
                if (res.code === 200) {
                  this.$message({ type: 'success', message: '注册成功!' })
                  this.$router.replace('/login')
                }
                this.loading = false
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            return false
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
.register{
  .el-input__inner{
    height: 49px;
  line-height: 49px;
  border: 0px solid #DCDFE6;
   background: #fff;
  }
}

.tabs{
  .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
}
.el-tabs__nav-wrap::after{
 position: static !important;
}

}
</style>

<style lang="scss" scoped>
.register_container {
  // background: #F6F7FB;
  background: linear-gradient( 180deg, #E8F1FB 0%, #FFFFFF 100%);
  // background-size: cover;
  width: 100%;
  height: 100vh;
  // overflow: hidden;
  // background-image: url(~@/assets/login/Maskgroup.jpg);
  // background-size: 100% 100%;
  .img {
    width: 100%;
    height: 24.65vw;
    // min-width: 1440px;
    min-height: 355px;
    position: absolute;
    bottom: 0;
    left: 0;
  }
.code-layout {
  display: flex;
  overflow: hidden;
  // align-items: center;
  // height: 37px;
  justify-content: space-between;
  width: 100%;
}
.text-style {
  font-family: PingFang SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.4px;
  cursor: pointer;
}

.btns {
  width: 100%;
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
}
.margin-top20 {
  margin-top: 20px;
}

.checked-forget {
  margin-top: -10px;
  width: 100%;
  display: flex;
  align-items: center;
}
.zsb-tyb {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 34px;
}
.ystk {
  color: #0f73e6;
}

.icon-zsb {
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
  span {
    margin-left: 4px;
    font-size: 16px;
    line-height: 22.4px;
  }
}
.el-icon-refresh {
  margin-bottom: 22px;
  margin-left: 8px;
}
.code-input {
  // width:calc(100vw - 160px);
  // width: 100%;
}
.code {
  height: 49px;
  font-size: 14px;
  margin-top: 1px;
  margin-left: 10px;
  text-align: center;
  // width: 120px;
  color: #fff;
  cursor: pointer;
}

.fhzsb {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
  .text {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    color: #b9babb;
    margin-left: 4px;
  }
}
.text1{
  font-size: 20px;
  margin-left: 15px;
  font-weight: 600;
  color: #555555;
  margin-top: 30px;
}
.text2{
  font-size: 12px;
  color: #555555;
  margin-left: 15px;
  margin-top: 10px;
}
.register-content{
  width: 100%;
  height: calc(100vh - 54px);
  overflow: auto;
}

.top-layout {
  display: flex;
  align-items: center;
  position: relative;
  height: 54px;
  .el-icon-arrow-left {
   font-size: 18px;
   font-weight: 600;
   margin-left: 15px;
   cursor: pointer;
  }
  div {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    font-size: 16px;
    font-weight: 800;
    line-height: 28px;
    text-align: left;
    color: #171717;
  }
}

.register {
  width: 100%;
  padding-top: 0px;
  padding: 30px 15px 15px 15px;
  border-radius: 0px;
  box-sizing: border-box;
  position: relative;
}

.login_logo {
  width: 120px;
  height: 120px;
  border: 5px solid #93defe;
  border-radius: 100px;
  background: #fff;
  text-align: center;
  line-height: 110px;
  position: absolute;
  top: -60px;
  right: 140px;
}

.login_name {
  width: 100%;
  text-align: center;
}

.login_name div {
  width: 100%;
  text-align: center;
  font-size: 24px;
  margin-bottom: 40px;
  line-height: 33.6px;
  font-weight: 500;
  color: #555555;
  font-family: PingFang SC;
}

.login_logo img {
  width: 100px;
  height: 70px;
  display: inline-block;
  vertical-align: middle;
}
.yszc{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #555;
  .blue{
    color: #0f73e6;

  }
}
}
</style>
